import { render, staticRenderFns } from "./regIndex.vue?vue&type=template&id=5bb6762f&scoped=true"
import script from "./regIndex.vue?vue&type=script&lang=js"
export * from "./regIndex.vue?vue&type=script&lang=js"
import style0 from "./regIndex.vue?vue&type=style&index=0&id=5bb6762f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6762f",
  null
  
)

export default component.exports